import React from 'react';
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { AlertTriangle } from 'lucide-react';

interface CustomizedFieldIndicatorProps {
  isCustomized?: boolean;
  context?: 'user' | 'client';
}

export const CustomizedFieldIndicator: React.FC<CustomizedFieldIndicatorProps> = ({ 
  isCustomized, 
  context 
}) => {
  if (!isCustomized || context !== 'client') return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" aria-label="This setting is customized for the client" onClick={(e) => e.preventDefault()}>
            <AlertTriangle className="h-3.5 w-3.5 text-amber-500" />
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>This setting is part of a client-specific override.</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
